<div class="common-contact-request-grid">
	<grid-content [setup]="setup()" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()"
		[rows]="data()"></grid-content>
</div>